import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getRedirectResult } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase/config";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    (async () => {
      try {
        const result = await getRedirectResult(auth);
        if (result?.user) {
          const fbUser = result.user;
          const snap = await getDoc(doc(db, "users", fbUser.uid));
          if (snap.exists()) {
            setUser({ uid: fbUser.uid, email: fbUser.email, ...snap.data() });
          } else {
            const newUser = {
              email: fbUser.email,
              displayName: fbUser.displayName || fbUser.email.split("@")[0],
              photoURL: fbUser.photoURL || "",
              plan: "free",
              isAdmin: false,
              createdAt: new Date().toISOString(),
              totalDocumentsScanned: 0,
              totalWordsProcessed: 0,
              dailyScansUsed: 0,
              lastScanDate: new Date().toISOString(),
            };
            await setDoc(doc(db, "users", fbUser.uid), newUser);
            setUser({ uid: fbUser.uid, ...newUser });
          }
          nav("/dashboard", { replace: true });
        } else {
          nav("/login", { replace: true });
        }
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background grid-bg">
      <div className="text-center">
        <Loader2 size={28} className="mx-auto animate-spin text-indigo-400"/>
        <div className="mt-3 text-sm text-zinc-400">Signing you in…</div>
      </div>
    </div>
  );
}
